export const facialRecognition = {
  'Identity confirmed. Returning to complete the signature…':
    'Identidad confirmada. Regresando para completar la firma…',
};
